import OrderSummaryBreakdown from "./OrderSummaryBreakdown";
import OrderSummaryLineItem from "./OrderSummaryLineItem";
import OrderSummaryAmounts from "./OrderSummaryAmounts";

const CentralOrderSummary = ({ order, isCheckoutPage = false, payLink = null }) => {
  return (
    <Fragment>
      {order?.order?.value?.lineItems?.map((lineItem, index) => {
        return (
          <OrderSummaryLineItem
            lineItem={lineItem}
            isCheckoutPage={isCheckoutPage}
            isLast={index === order?.order?.value?.lineItems?.length - 1}
          />
        );
      })}
      {order?.order?.value?.showAdjustmentBreakdown ? (
        <OrderSummaryBreakdown
          order={order}
          subTotal={order?.order?.value?.totals?.subTotal?.value}
          total={order?.order?.value?.totals?.transactionAmount}
          adjustments={order?.order?.value?.adjustments}
          tipAmount={order?.order?.value?.totals?.tipAmount}
          payLink={payLink}
        />
      ) : (
        <OrderSummaryAmounts
          discountTotal={order?.order?.value?.totals?.discountTotal?.value}
          feeTotal={order?.order?.value?.totals?.feeTotal?.value}
          taxTotal={order?.order?.value?.totals?.taxTotal?.value}
          subTotal={order?.order?.value?.totals?.subTotal?.value}
          shippingTotal={order?.order?.value?.totals?.shippingTotal?.value}
          tipAmount={order?.order?.value?.totals?.tipAmount}
          total={order?.order?.value?.totals?.transactionAmount}
          payLink={payLink}
        />
      )}
    </Fragment>
  );
};

export default CentralOrderSummary;
